import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import NuxtLoading from './components/nuxt-loading.vue';

import '../src/assets/sass/main.sass';

import '../src/assets/css/styles.css';

import '../node_modules/dropzone/dist/dropzone.css';

import '../node_modules/@fortawesome/fontawesome-svg-core/styles.css';

var layouts = {

  "_ad": function _ad() {
    return import('../src/layouts/ad.vue' /* webpackChunkName: "layouts/ad" */).then(function (m) {
      return m.default || m;
    });
  },

  "_affiliations": function _affiliations() {
    return import('../src/layouts/affiliations.vue' /* webpackChunkName: "layouts/affiliations" */).then(function (m) {
      return m.default || m;
    });
  },

  "_default": function _default() {
    return import('../src/layouts/default.vue' /* webpackChunkName: "layouts/default" */).then(function (m) {
      return m.default || m;
    });
  },

  "_login": function _login() {
    return import('../src/layouts/login.vue' /* webpackChunkName: "layouts/login" */).then(function (m) {
      return m.default || m;
    });
  },

  "_stepped": function _stepped() {
    return import('../src/layouts/stepped.vue' /* webpackChunkName: "layouts/stepped" */).then(function (m) {
      return m.default || m;
    });
  }

};

var resolvedLayouts = {};

export default {
  head: { "titleTemplate": "Niubiz Afiliación - %s", "link": [{ "rel": "stylesheet", "type": 'text/css', "href": 'https://fonts.googleapis.com/icon?family=Material+Icons' }, { "rel": "stylesheet", "type": 'text/css', "href": 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css' }], "meta": [{ "charset": "utf-8" }, { "name": "viewport", "content": "width=device-width, initial-scale=1" }, { "hid": "description", "name": "description", "content": "Meta description" }], "script": [{ "src": 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=es', "async": true, "defer": true }], "style": [] },
  render: function render(h, props) {
    var loadingEl = h('nuxt-loading', { ref: 'loading' });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);

    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [templateEl]);

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },

  data: function data() {
    return {
      layout: null,
      layoutName: ''
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this;
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this;
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
  },
  mounted: function mounted() {
    this.$loading = this.$refs.loading;
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  methods: {
    errorChanged: function errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail();
        if (this.$loading.finish) this.$loading.finish();
      }
    },
    setLayout: function setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default';
      this.layoutName = layout;
      var _layout = '_' + layout;
      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      var _this = this;

      if (!layout || !(layouts['_' + layout] || resolvedLayouts['_' + layout])) layout = 'default';
      var _layout = '_' + layout;
      if (resolvedLayouts[_layout]) {
        return _Promise.resolve(resolvedLayouts[_layout]);
      }
      return layouts[_layout]().then(function (Component) {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(function (e) {
        if (_this.$nuxt) {
          return _this.$nuxt.error({ statusCode: 500, message: e.message });
        }
      });
    }
  },
  components: {
    NuxtLoading: NuxtLoading
  }
};


//////////////////
// WEBPACK FOOTER
// ./.nuxt/App.js
// module id = ./.nuxt/App.js
// module chunks = 34